module.exports = __webpack_public_path__ + "img/background_4.3a5723c9.png";